import React, { useEffect, useState } from 'react';
import ConfigService from '@services/config.service';
import SwiperCore, { A11y, Autoplay, Navigation, Pagination, Scrollbar } from 'swiper';
import { getLocaleContent } from '@helper/locale-content.js';
import { useRouter } from 'next/router';

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay]);

export default function SlideHome({ bannerHomeSlide = [], bannerSaleTop = [] }) {
    const { locale } = useRouter();
    const [stats, setStats] = useState({
        facilities: '0',
        beds: '0',
        doctors: '0',
        patients: '0',
    });

    useEffect(() => {
        const fetchStats = async () => {
            const configService = new ConfigService();
            try {
                const response = await configService.postAppConfig(
                    'WEB_NUM_HOSPITAL_FACILITIES,WEB_NUM_HOSPITAL_BEDS,WEB_NUM_HOSPITAL_DOCTORS,WEB_NUM_HOSPITAL_PATIENTS_SERVED',
                );
                setStats({
                    facilities: response?.WEB_NUM_HOSPITAL_FACILITIES || '0',
                    beds: response?.WEB_NUM_HOSPITAL_BEDS || '0',
                    doctors: response?.WEB_NUM_HOSPITAL_DOCTORS || '0',
                    patients: response?.WEB_NUM_HOSPITAL_PATIENTS_SERVED || '0',
                });
            } catch (error) {
                console.error('Failed to fetch stats:', error);
            }
        };

        fetchStats();
    }, []);

    return (
        <>
            <section className="stats">
                <div className="container stats__grid">
                    <div className="stat">
                        <div className="stat__icon">
                            <img src="/bw_image/ic_hospital.svg" alt="Cơ sở TNH" />
                        </div>
                        <div className="stat__body">
                            <div className="stat__num">{stats.facilities}</div>
                            <div className="stat__label">{getLocaleContent(locale, 'page.counter-bar.medical-facilities')}</div>
                        </div>
                    </div>
                    <div className="stats__sepvertical"></div>
                    <div className="stat">
                        <div className="stat__icon">
                            <img src="/bw_image/ic_bed.svg" alt="Giường bệnh" />
                        </div>
                        <div className="stat__body">
                            <div className="stat__num">{stats.beds}</div>
                            <div className="stat__label">{getLocaleContent(locale, 'page.counter-bar.bed')}</div>
                        </div>
                    </div>
                    <div className="stats__sep2"></div>
                    <div className="stat">
                        <div className="stat__icon">
                            <img src="/bw_image/ic_doctor.svg" alt="Chuyên gia Bác sĩ" />
                        </div>
                        <div className="stat__body">
                            <div className="stat__num">{stats.doctors}</div>
                            <div className="stat__label">{getLocaleContent(locale, 'page.counter-bar.doctor')}</div>
                        </div>
                    </div>
                    <div className="stats__sepvertical"></div>
                    <div className="stat">
                        <div className="stat__icon">
                            <img src="/bw_image/ic_patient.svg" alt="Bệnh nhân" />
                        </div>
                        <div className="stat__body">
                            <div className="stat__num">{stats.patients}</div>
                            <div className="stat__label">{getLocaleContent(locale, 'page.counter-bar.patient')}</div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
